import { Pipe, PipeTransform } from '@angular/core';
import { Vat } from '../models/domain/Vat';

@Pipe({
    name: 'valueExistsInVats',
    standalone: false
})
export class ValueExistsInVatsPipe implements PipeTransform {
    transform(value: string, vats: Vat[]): boolean {
        if (value === null || Number.isNaN(value)) {
            return false;
        }
        const vat = Number.parseFloat(value);
        if (vats.find(x => x.Value === vat)) {
            return true;
        }
        return false;
    }
}
